import React from 'react';
import moment from 'moment';
import {
    Chart,
    Series,
    ArgumentAxis,
    CommonSeriesSettings,
    Export,
    Legend,
    Margin, Point
} from 'devextreme-react/chart';
import { SubAccount, ClientsAPI } from 'src/api'

// import fullData from '../../data/channel_area.json';

type Data = Array<{
    period: number;
    month?: number;
    date?: string
}>

type Props = {
    client?: SubAccount
}
// const types = ['area', 'stackedarea', 'fullstackedarea'];

class AreaChannel extends React.Component<Props> {
    state = {
        data: undefined,
        narrative: undefined
    }
    fetchData = (client: SubAccount) => {
        // const params = {
        //     narrative_assembly_id: "3870d92a-e82c-11ea-86cf-0e95a518f8f7",
        //     report_content_id: "16ce3654-efc5-11ea-86cf-0e95a518f8f7",
        //     sub_account_id: client.id,
        //     period_index: "1449",
        //     period_type: "monthly"
        // }

        ClientsAPI.getReportData(client, 'channel_area.json').then(result => {
            // console.log('done', result)
            this.setState({ data: result.data });
        }).catch(error => {
            // console.log('error', error)
        })

        // ClientsAPI.getNarrative(client, params).then(result => {
        //     // console.log('done', result)
        //     this.setState({ narrative: result[0] });
        // }).catch(error => {
        //     // console.log('error', error)
        // })
    }
    constructor(props: Readonly<{}>) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        // this.customizeLabel = this.customizeLabel.bind(this);
    }

    handleChange(e: { value: any; }) {
        this.setState({
            type: e.value
        });
    }

    parseMonthData(data: Data | any) {
        const result = data.map((d: { period: number; month: number; date: string; }) => {

            const month = (d.period % 12) + 1
            const year = 1900 + (d.period - (d.period % 12)) / 12
            const date = moment(`${month} ${year}`, "M YYYY").format('MMM YYYY')
            d.month = month
            d.date = date
            return d
        })

        return result;
    }
    getCurrentData(data: Data|any) {
        return data.slice(-1)[0]
    }

    // customizeLabel= (arg: { value: number; }) =>{
    //     if (arg.value == this.getCurrentData(data).period) {
    //         return {
    //             visible: true,
    //             backgroundColor: '#ff7c7c',
    //             customizeText: function (e: { valueText: any; }) {
    //                 return `${e.valueText}&#176F`;
    //             }
    //         };
    //     }
    //     return []
    // }


    render() {
        const { data, narrative } = this.state
        const { client } = this.props;


        if (!data && client) {
            this.fetchData(client);
        }

        if (!data) return null;

        return (
            <div id="chart-demo">
                <Chart
                    palette="Harmony Light"
                    title="Total Sessions: Channels Structure over past 15 months"
                    // customizeLabel={this.customizeLabel}

                    dataSource={this.parseMonthData(data)}
                >
                    <CommonSeriesSettings
                        argumentField="date"
                        type='area'
                    >
                        <Point visible={false} />
                    </CommonSeriesSettings>

                    <Series valueField="Organic Search" name="Organic Search"></Series>
                    <Series valueField="Paid Search" name="Paid Search"></Series>
                    <Series valueField="Referral" name="Referral"></Series>
                    <Series valueField="Social" name="Social"></Series>

                    <Margin bottom={20} />
                    <ArgumentAxis valueMarginsEnabled={false} />
                    <Legend
                        verticalAlignment="bottom"
                        horizontalAlignment="center"
                    />
                    <Export enabled={true} />
                </Chart>

            </div>
        );
    }
}

export default AreaChannel;


// WEBPACK FOOTER //
// ./src/components/ReportComponents/AreaChannel.tsx